import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../utils/styles'

const Button = props => {
  const { children } = props
  return <Box {...props}>{children}</Box>
}

export default Button

export const Box = styled.button`
  width: 100%;
  background: ${props => (props.background ? props.background : '#215041')};
  color: ${props => (props.color ? props.color : 'white')};
  font-family: 'SohneBreit';
  font-weight: 400;
  letter-spacing: 1px;
  border: none;
  text-align: center;
  border-radius: 50px;
  font-size: 16px;
  max-width: 280;
  cursor: pointer;
  line-height: 40px;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }
`
